import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { NewPassword } from "@unisearch/auth";

const New = () => {
  return (
    <LayoutMain
      title="New Password"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/new-password`}
    >
      <NewPassword />
    </LayoutMain>
  );
};

export default New;
